import React from 'react';
import TermsView from '@fingo/lib/features/terms/views/TermsView';
import { REQUESTING_PLATFORM_TO_CODES } from '@fingo/lib/constants/requesting-platform';

const Terms = () => (
  <TermsView
    credentialsSource={REQUESTING_PLATFORM_TO_CODES.BCH}
    cannotAcceptDescription="Por favor reintenta nuevamente, si el problema persiste, comunícate con FonoBank."
    privacyPolicyUrl="https://sitiospublicos.bancochile.cl/personas/politica-de-privacidad"
  />
);

export default Terms;
